import { Fade, Grid, Modal } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import ParserComments from '../../Helpers/ParserComents'

import Context from '../../../../context'
import CommentsTable from './CommentsTable'
import StyledTab from './StyledTab'
import StyledTabs from './StyledTabs'
import TabPanel from './TabPanel'

import useStyles from './styles'

function CommentsModal() {
  const classes = useStyles()
  const { openModal, setOpenModal, validationsList } = useContext(Context)

  const [publicCommentList, setPublicCommentList] = useState([])
  const [privateCommentList, setPrivateCommentList] = useState([])
  const [TabValue, setTabValue] = useState(1)

  useEffect(() => {
    setPublicCommentList(ParserComments('publicComment', validationsList))
    setPrivateCommentList(ParserComments('privateComment', validationsList))
  }, [validationsList])

  const handleClose = () => {
    setOpenModal(false)
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue)
  }

  return (
    <Modal className={classes.commentsModal} open={openModal} onClose={handleClose}>
      <Fade in={openModal}>
        <div className={classes.commentsPaper}>
          <Grid container>
            <Grid item xs={12}>
              <StyledTabs value={TabValue} onChange={handleChange} aria-label="styled tabs example">
                <StyledTab label="COMENTÁRIOS" disabled />
                <StyledTab label="PÚBLICOS" />
                <StyledTab label="PRIVADOS" />
              </StyledTabs>
              <TabPanel value={TabValue} index={1}>
                <CommentsTable tableData={publicCommentList} />
              </TabPanel>
              <TabPanel value={TabValue} index={2}>
                <CommentsTable tableData={privateCommentList} />
              </TabPanel>
            </Grid>
          </Grid>
        </div>
      </Fade>
    </Modal>
  )
}

export default CommentsModal
